import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export default function ConfirmationMessage({
  open,
  removeConfirmationMessage,
  agreeConfirmation,
  disagreeConfirmation,
}) {
  // const [open, setOpen] = React.useState(false);

  // const handleClickOpen = () => {
  //   setOpen(true);
  // };

  const handleClose = () => {
    removeConfirmationMessage();
  };
  const handleAgree = () => {
    agreeConfirmation();
  };
  const handleDisagree = () => {
    disagreeConfirmation();
  };

  return (
    <div id="confirmation-popup">
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          padding: "50px",
          borderRadius: "20px",
        }}
      >
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are you sure you wanted to exit the route ?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button id="confirmno" onClick={handleDisagree}>
            No
          </Button>
          <Button id="confirmyes" onClick={handleAgree} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
